export default __webpack_public_path__ + "static/media/fleet-edge-icon.6f850b71.svg";